import endOfDay from "date-fns/endOfDay";
import startOfDay from "date-fns/startOfDay";
import { QueryFunctionContext } from "react-query";
import { RATE_CARD_QUERY_TYPES } from "utils/constants";
import { JwtClient } from "utils/jwtClient";

import { formatAvailablePlans } from "./pricing.utils";

type GetRateCardsProps = {
  generationPriceContract?: string;
  icpNumber?: string;
  jwtClient: JwtClient;
  supplyNodeRef?: string;
  type: string;
  usageType?: string;
  locationClassification?: string;
};

// This query is called in two ways. To get rate cards or to get current available plans
// the 'type' param dictates what queryParams to set, and how the data is returned
export const getRateCards = async ({
  queryKey,
}: QueryFunctionContext<[string, GetRateCardsProps]>): Promise<
  | {
      data: RateCard[];
    }
  | AvailablePlan[]
> => {
  const [
    _,
    {
      icpNumber,
      generationPriceContract,
      jwtClient,
      supplyNodeRef,
      type,
      usageType,
      locationClassification,
    },
  ] = queryKey;
  const queryParams =
    type === RATE_CARD_QUERY_TYPES.rateCards
      ? {
          ea_icp_id: icpNumber,
          start_at: startOfDay(new Date()).toISOString(),
          end_at: endOfDay(new Date()).toISOString(),
          generation_price_contract: generationPriceContract,
          ...(usageType && { usage_type: usageType }),
          ...(locationClassification && {
            location_classification: locationClassification,
          }),
        }
      : {
          start_at: startOfDay(new Date()).toISOString(),
          end_at: endOfDay(new Date()).toISOString(),
          brand: "flick",
          existing_customer_plans: true,
          supply_node_ref: supplyNodeRef,
          ...(Boolean(usageType) && { usage_type: usageType }),
          ...(Boolean(locationClassification) && {
            location_classification: locationClassification,
          }),
        };
  const response = await jwtClient.apiCall({
    path: "/pricing/rate_cards",
    queryParams,
  });
  if (type === RATE_CARD_QUERY_TYPES.availablePlans) {
    const { data } = await response.json();
    return formatAvailablePlans(data);
  }
  return await response.json();
};
